import React from "react";

const Kalvipani = () => {
  const styles = {
    container: {
      maxWidth: "1200px",
      margin: "20px auto",
      padding: "2rem",
      fontFamily: "'Hind Madurai', 'Arial Unicode MS', sans-serif",
      backgroundColor: "#f9f4e8",
      borderRadius: "10px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      lineHeight: "1.6",
      color: "#333"
    },
    header: {
      textAlign: "center",
      marginBottom: "2rem",
      borderBottom: "2px solid #d4a76a",
      paddingBottom: "1rem"
    },
    title: {
      fontSize: "1.8rem",
      color: "#8e2323",
      fontWeight: "700",
      textShadow: "1px 1px 2px rgba(0,0,0,0.1)"
    },
    content: {
      padding: "0 1rem"
    },
    paragraph: {
      fontSize: "1.1rem",
      textAlign: "justify",
      marginBottom: "1.5rem",
      color: "#444"
    },
    specialText: {
      color: "#8e2323",
      fontWeight: "600"
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>மாணவர்களுக்கான பயிலரங்கம்</h1>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <img src="https://makalukkaga.mpeoplesnet.com/podhu/podhu3.png" alt="" />
      </div>
      <div style={styles.content}>
        <p style={styles.paragraph}>
          <span style={styles.specialText}>
            மாணிக்கம்பாளையம் கிராமத்தில் வசிக்கும் பள்ளி
          </span>{" "}
          மாணவர்களுக்கான ஒருநாள் பயிலரங்கம் 20.6.2009 ஆம் தேதி
          மாணிக்கம்பாளையத்திலுள்ள பாரதி அரங்கத்தில் நடைப்பெற்றது. 250 மாணவர்கள்
          பங்கேற்ற இப்பயிலரங்கத்தில் தன்னம்பிக்கையே அடிப்படை என்ற தலைப்பில்
          மக்கள் சிந்தனைப் பேரவையின் தலைவர் த.ஸ்டாலின் குணசேகரன், தேர்வுகளில்
          சிறப்பான வெற்றி என்ற தலைப்பில் பேராசிரியர் ஆ. இரத்தினசாமி ஆங்கில
          மொழியைக் கற்க எளிய முறையில் படிக்கும் வழிகள் என்ற தலைப்பில் ஆசிரியர்
          செ. மோகனசுந்தரம் ஆகியோர் கருத்துரையாற்றினர்.
        </p>
        <p style={styles.paragraph}>
          <span style={styles.specialText}>
            இந்நிகழ்ச்சியில் பெரிய சேமூர் நகரமன்றத் தலைவர் எஸ்.டி. பிரபாகரன்,
            வார்டு உறுப்பினர் சி. ஸ்ரீதர் ஆகியோர்
          </span>{" "}
          மாணவர்களை வாழ்த்திப் பேசினர். ஒருநாள் முழுக்க சிறப்பாக நடைப்பெற்ற
          அப்பயிலரங்கத்தில் அரசுப்பள்ளிகளில் படிக்கும் ஏழை, எளிய மாணவர்கள்
          ஆர்வத்துடன் பங்கேற்றதோடு மிகவும் பயன்பெற்றனர். காலை, மாலை தேனீர் மதிய
          உணவு ஆகிய செலவுகளை பேரவையின் வேண்டுகோளுக்கு இணங்க நகர் மன்றத் தலைவரே
          ஏற்றார். இந்த பயிலரங்கிக்கு மட்டுமல்லாது பேரவை நடத்துகிற அனைத்துப்
          பயிலரங்களுக்குமே நுழைவுக் கட்டணம் ஏதும் வசூலிக்கப்படவில்லை.
        </p>
        <p style={styles.paragraph}>
          இப்பயிலரங்கம் கிராமப்புற மாணவர்களின் கல்வி மேம்பாட்டிற்காகவே சேவைத்
          திட்டமாக ஏற்பாடு செய்யப் பட்டதாகும். இதில் பங்கேற்ற அனைத்து
          மாணவர்களுக்கும் சான்றிதழ் வழங்கப்பட்டது.
        </p>
      </div>
    </div>
  );
};

export default Kalvipani;
